import React, { Component } from "react";
import { Fab } from "@material-ui/core";
import { Add, Done } from '@material-ui/icons';
import { connect } from "react-redux";
import {webFont, textBlack, textGrey, primaryColor} from "../../config/theme";
import {addDish,removeDish} from "../../redux/bookings";
import DishesListBox from "../DishesListBox";

const defaultChefImg = "/images/simple-chef.webp";


class SinDish extends Component {
  state = {
    isSelected: false,
    chefDetails: {},
  };


  handleAddDishClick = dish =>{
    const { dispatch } = this.props;
    dispatch(addDish(dish));
    this.setState({isSelected:true});
    this.props.refreshBookNow();
  }

  handleRemoveDishClick = dish => {
    const { dispatch } = this.props;
    dispatch(removeDish(dish));
    this.setState({isSelected:false});
    this.props.refreshBookNow();
  }


  render() {
    const {dish, isChef, viewAsDiner} = this.props;
    let { isSelected }= this.state;
    // const indexInCart = cart.findIndex(item => item.id === dish.id);

    const addToCart = <Fab
      data-test-id={"dishtocart-id"}
      id={`dish-item-${dish.id}`}
      size={'small'}
      variant={'round'}
      disableRipple={true}
      disableFocusRipple={true}
      onClick={()=>this.handleAddDishClick(dish)}
      style={{
        zIndex: 99,
        position: 'absolute',
        top: 20,
        right: 40,
        backgroundColor: '#fff',
        borderWidth: 3,
        borderColor: primaryColor,
        borderStyle: 'solid'
      }}
    >

      <Add color={'primary'} />
    </Fab>;

    const removeFromCart = <Fab
      data-test-id={"remfromcart-id"}
      size={'small'}
      variant={'round'}
      disableRipple={true}
      disableFocusRipple={true}
      onClick={()=>this.handleRemoveDishClick(dish)}
      style={{
        zIndex: 99,
        position: 'absolute',
        top: 20,
        right: 40,
        color: '#fff',
        borderWidth: 3,
        borderColor: primaryColor,
        borderStyle: 'solid',
        backgroundColor: primaryColor,
      }}
    >
      <Done />
    </Fab>;

    return (
      <DishesListBox
        dishImage={dish.media ? dish.media.length > 0 ? dish.media[0].url : defaultChefImg : defaultChefImg}
        dishHeading={dish.name}
        dishDetail={dish.cuisines ? dish.cuisines.toString().replace(/,/g, ', ') : ""}
        dish={dish}
        handleClick={this.props.handleClick}
        editChef={this.props.isPublicProfile ? null : !isChef && (isSelected ? removeFromCart : addToCart)}
      />
    );

  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    cart: state.bookings.cart,
    selectedChefid: state.bookings.selectedChefId,
    selectedChef: state.bookings.selectedChef,
    chefAvailbility: state.bookings.chefAvailbility,
    viewAsDiner: state.user.viewAsDiner,
  };
};

const SingleDish = connect(mapStateToProps)(SinDish);



export default SingleDish;

const style = {
  avatarImg: {
    width: '97%',
    height: 210,
    borderRadius: 5
  },
  avatarImgMob: {
    width: '97%',
    height: 160,
    borderRadius: 5,
    marginLeft: 40
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 80,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    paddingLeft: 25
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
    paddingLeft: 20
  },
  dishName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    maxWidth: 400,
    paddingLeft: 20,
    marginTop: 10
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    width: '220px',
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: 'none',
    marginTop: 30,
    fontFamily: webFont
  }
};
